import React from 'react'
import GameLauncher from '../components/GameLauncher'

export default class GameLauncherContainer extends React.Component {
    render() {
        return (
            <div>
                <GameLauncher />
            </div>
        )
    }
}
